export const catalog = {
  catalogSearchInputPlaceholderTitle: '검색',
  catalogHeaderTitle: '상세정보',
  catalogDetailsCurtainCopyOptionTitle: '링크 복사',
  catalogDetailsLinkCрiedAlertText: '링크가 복사되었습니다!',
  catalogDetailsCurtainFlagOptionTitle: '콘텐츠 신고',
  catalogDetailsFlagCurtainTitle: '신고',
  catalogReportedCurtainContent: '콘텐츠가 신고되었습니다',
  catalogWantBuy: '{app}에서 {item}을(를) 구매하고 싶어요',
  catalogInterestedIn: '{link}'
}
